<template>
	<div class="container address">
        <div class="row">
            <div class="col-4 icon-master">
                <i class="fa fa-phone"></i>
            </div>

            <div class="col-8">
                <div class="headline h2 tc">
                    <span>Wie erreichen wir Dich?</span>
                </div>
                
                <div class="row" >
                    <div class="input-group col-6" >
                        <input v-model="forename" placeholder="Vorname" v-validate="'required'" >
                    </div>
                    <div class="input-group col-6">
                        <input v-model="lastname" placeholder="Nachname" v-validate="'required'" >
                    </div>
                    <div class="input-group col-6">
                        <input v-model="phone" placeholder="Telefonnummer" v-validate="'required'" >
                    </div> 
                    <div class="input-group col-6">
                        <input v-model="mail" placeholder="E-Mail Adresse" v-validate="'required|email'" >
                    </div>
                </div>
            </div>
            
        </div>
    </div>

</template>

<script>
export default {
	name: 'contractData',
	components: {
		
	},

	data: function () {
        return {
          forename: '',
          lastname: '',
          phone: '',
          mail: '',
        }
    },

    mounted() {
        
    },

    methods: {
        nextPage() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    // Success
                    this.$emit('openNextPage', this);
                    return;
                }
                if(!result){
                    // Error
                    console.log(this);
                }
            });
        }
    }
}
</script>
